/* lib/overlay.jsx — общие хелперы оверлеев: focus-trap, body-scroll-lock, ESC.
   Используются Drawer / Modal / ConfirmDialog. */

import React from 'react';

  const { useEffect, useRef } = React;

  let lockCount = 0;
  function lockScroll() {
    if (lockCount === 0) {
      const sw = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      if (sw > 0) document.body.style.paddingRight = sw + 'px';
    }
    lockCount++;
    return () => {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount === 0) { document.body.style.overflow = ''; document.body.style.paddingRight = ''; }
    };
  }

  const FOCUSABLE = 'a[href],button:not([disabled]),textarea,input,select,[tabindex]:not([tabindex="-1"])';

  // useFocusTrap(ref, { active, onEscape, initialFocus }) — ловит Tab внутри узла
  function useFocusTrap(ref, { active = true, onEscape, autoFocusSelector } = {}) {
    const prevFocus = useRef(null);
    useEffect(() => {
      if (!active) return;
      const node = ref.current;
      if (!node) return;
      prevFocus.current = document.activeElement;

      // начальный фокус
      const focusTarget = autoFocusSelector ? node.querySelector(autoFocusSelector) : null;
      const first = focusTarget || node.querySelector(FOCUSABLE) || node;
      setTimeout(() => { try { first.focus(); } catch (e) {} }, 0);

      const onKey = (e) => {
        if (e.key === 'Escape') { e.stopPropagation(); onEscape && onEscape(); return; }
        if (e.key !== 'Tab') return;
        const items = Array.from(node.querySelectorAll(FOCUSABLE)).filter((el) => el.offsetParent !== null);
        if (!items.length) { e.preventDefault(); return; }
        const firstEl = items[0], lastEl = items[items.length - 1];
        if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
        else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
      };
      node.addEventListener('keydown', onKey);
      return () => {
        node.removeEventListener('keydown', onKey);
        const prev = prevFocus.current;
        if (prev && prev.focus) setTimeout(() => { try { prev.focus(); } catch (e) {} }, 0);
      };
    }, [active]);
  }

  // useScrollLock(active)
  function useScrollLock(active) {
    useEffect(() => {
      if (!active) return;
      const release = lockScroll();
      return release;
    }, [active]);
  }

  export const overlay = { useFocusTrap, useScrollLock, FOCUSABLE };

  // общий портал-узел оверлеев — определён в group 1, до Modal/Drawer/Popover
  function getOverlayRoot() {
    let el = document.getElementById('overlay-root');
    if (!el) { el = document.createElement('div'); el.id = 'overlay-root'; document.body.appendChild(el); }
    return el;
  }

export { getOverlayRoot };
